export default __webpack_public_path__ + "static/media/hero-bcg2.ac32cdf4.jpg";